/**
 * DeliverFresh Advanced Predictive Search
 */
(function () {
  'use strict';

  const POPULAR_SEARCHES = ['Carrots', 'Okra', 'Ginger', 'Indian Veg', 'Fruit Box', 'Organic'];
  const CATEGORIES = [
    { label: 'Vegetables', url: '/collections/fresh-vegetables' },
    { label: 'Fruits', url: '/collections/fresh-fruits' },
    { label: 'Indian Veg', url: '/collections/indian-vegetables' },
    { label: 'Bundles', url: '/collections/bundles' },
  ];

  let overlay, input, resultsContainer, debounceTimer, controller;

  function init() {
    overlay = document.getElementById('df-search-overlay');
    input = document.getElementById('df-search-input');
    resultsContainer = document.getElementById('df-search-results');

    if (!overlay || !input) return;

    // Open triggers
    document.querySelectorAll('.df-search-trigger').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        openSearch();
      });
    });

    // Close triggers
    document.getElementById('df-search-close').addEventListener('click', closeSearch);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeSearch();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('df-search-open')) {
        closeSearch();
      }
    });

    // Input handling
    input.addEventListener('input', function () {
      var query = input.value.trim();
      clearTimeout(debounceTimer);
      if (query.length < 2) {
        showDefaultContent();
        return;
      }
      debounceTimer = setTimeout(function () {
        fetchResults(query);
      }, 300);
    });

    // Popular search chips
    document.querySelectorAll('.df-search-chip').forEach(function (chip) {
      chip.addEventListener('click', function () {
        input.value = chip.textContent;
        fetchResults(chip.textContent);
      });
    });
  }

  function openSearch() {
    overlay.classList.add('df-search-open');
    document.body.style.overflow = 'hidden';
    setTimeout(function () {
      input.focus();
    }, 100);
    showDefaultContent();
  }

  function closeSearch() {
    overlay.classList.remove('df-search-open');
    document.body.style.overflow = '';
    input.value = '';
  }

  function showDefaultContent() {
    resultsContainer.innerHTML =
      '<div class="df-search-defaults">' +
      '<div class="df-search-section">' +
      '<h4 class="df-search-section-title">Popular Searches</h4>' +
      '<div class="df-search-chips">' +
      POPULAR_SEARCHES.map(function (s) {
        return '<button class="df-search-chip" type="button">' + s + '</button>';
      }).join('') +
      '</div>' +
      '</div>' +
      '<div class="df-search-section">' +
      '<h4 class="df-search-section-title">Categories</h4>' +
      '<div class="df-search-categories">' +
      CATEGORIES.map(function (c) {
        return '<a href="' + c.url + '" class="df-search-cat-link">' + c.label + '</a>';
      }).join('') +
      '</div>' +
      '</div>' +
      '</div>';

    // Re-bind chip clicks
    resultsContainer.querySelectorAll('.df-search-chip').forEach(function (chip) {
      chip.addEventListener('click', function () {
        input.value = chip.textContent;
        fetchResults(chip.textContent);
      });
    });
  }

  function fetchResults(query) {
    // Show loading
    resultsContainer.innerHTML =
      '<div class="df-search-loading">' +
      '<div class="df-search-spinner"></div>' +
      '<span>Searching...</span>' +
      '</div>';

    // Cancel previous request
    if (controller) controller.abort();
    controller = new AbortController();

    var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product&resources[limit]=6';

    fetch(url, { signal: controller.signal })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var products = data.resources && data.resources.results && data.resources.results.products
          ? data.resources.results.products
          : [];
        renderResults(products, query);
      })
      .catch(function (err) {
        if (err.name !== 'AbortError') {
          resultsContainer.innerHTML =
            '<div class="df-search-no-results">Something went wrong. Please try again.</div>';
        }
      });
  }

  function renderResults(products, query) {
    if (products.length === 0) {
      resultsContainer.innerHTML =
        '<div class="df-search-no-results">' +
        '<p>No results found for "<strong>' + escapeHtml(query) + '</strong>"</p>' +
        '<p style="font-size:13px;color:#6b7280;margin-top:8px;">Try a different search term or browse our categories below.</p>' +
        '<div class="df-search-categories" style="margin-top:16px;">' +
        CATEGORIES.map(function (c) {
          return '<a href="' + c.url + '" class="df-search-cat-link">' + c.label + '</a>';
        }).join('') +
        '</div>' +
        '</div>';
      return;
    }

    var html =
      '<div class="df-search-results-header">' +
      '<span>Results for "<strong>' + escapeHtml(query) + '</strong>"</span>' +
      '<a href="/search?q=' + encodeURIComponent(query) + '" class="df-search-view-all">View all results &rarr;</a>' +
      '</div>' +
      '<div class="df-search-product-grid">';

    products.forEach(function (product) {
      var image = product.image || '';
      var price = product.price ? formatMoney(product.price) : '';
      html +=
        '<a href="' + product.url + '" class="df-search-product">' +
        (image ? '<img src="' + image + '" alt="' + escapeHtml(product.title) + '" class="df-search-product-img" loading="lazy">' : '<div class="df-search-product-img df-search-no-img"></div>') +
        '<div class="df-search-product-info">' +
        '<span class="df-search-product-title">' + escapeHtml(product.title) + '</span>' +
        '<span class="df-search-product-price">' + price + '</span>' +
        '</div>' +
        '</a>';
    });

    html += '</div>';
    resultsContainer.innerHTML = html;
  }

  function formatMoney(cents) {
    return '$' + (parseFloat(cents) / 1).toFixed(2);
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
